import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import JobZImage from "../../../../common/jobz-img";
import { publicUser } from "../../../../../globals/route-names";
// import processLogin from "../../../../form-processing/login";
import { useTranslation } from "react-i18next";
// import { formType } from "../../../../../globals/constants";
import axiosInstance from '../../../../../axiosInstance';
import { API_URL } from "../../../../../config";
import { toast } from "react-toastify";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { Helmet } from 'react-helmet-async';


// const loginUser = async (userData, navigate) => {
//     console.log("Sending API Request with Data:", userData);

//     try {
//         const response = await axiosInstance.post(`${API_URL}/login`, userData);
//         console.log("API Response:", response.data);

//         if (response.data.token) {
//             console.log("Token received:", response.data.token);
//             localStorage.setItem("authToken", response.data.token);
//             localStorage.setItem("role", response.data.data.role)
//             navigate("/candidate/dashboard");
//             window.location.reload();
//         } else {
//             toast.error(response.data.message || "Login failed");
//         }
//     } catch (error) {
//         const message = error.response?.data?.message || "Login error";
//         toast.error(message);
//     }
// };

const firebaseConfig = {
    apiKey: "AIzaSyBLDq9cSQHCoBwXWG6HOZWddMw-6I6JBgU",
    authDomain: "job-ai-7301e.firebaseapp.com",
    projectId: "job-ai-7301e",
    storageBucket: "job-ai-7301e.firebasestorage.app",
    messagingSenderId: "858464962767",
    appId: "1:858464962767:web:5919ff81b7120c7f808fba",
    measurementId: "G-ZBVMCNS3LJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

function LoginPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [captchaToken, setCaptchaToken] = useState(null);

    const captchaRef = useRef(null);

    // --------------------------------------------
    // PROFILE COMPLETION CHECK FUNCTION
    // --------------------------------------------
    const checkProfileAndRedirect = async (navigate) => {
        try {
            const res = await axiosInstance.get(`${API_URL}/candidate-profile`);
            const profile = res.data.data;

            const required = [
                profile.first_name,
                profile.last_name,
                profile.mobile,
                profile.qualification,
                profile.city,
                profile.state,
                profile.country,
                profile.designation,
                profile.experience,
                profile.description,
                profile.cv_path
            ];

            const isComplete = required.every(v => v && v !== "");

            if (!isComplete) {
                toast.warning("Please complete your profile.");
                navigate("/candidate/profile");
                return;
            }

            // If complete
            navigate("/candidate/dashboard");

        } catch (err) {
            console.error(err);
            toast.error("Profile check failed.");
        }
    };

    useEffect(() => {
        const authToken = localStorage.getItem("authToken");
        const role = localStorage.getItem("role");
        if (authToken && role === "candidate") {
            navigate("/candidate/dashboard");
        }
    }, [navigate]);

    const handleLogin = async (event) => {
        event.preventDefault();

        if (!email || !password) {
            toast.error("Please fill all fields!");
            return;
        }

        if (!captchaToken) {
            toast.error("Please complete Captcha!");
            return;
        }

        try {
            const response = await axiosInstance.post(`${API_URL}/login`, {
                loginType: "email",
                email,
                password
            });

            if (response.data.token) {
                localStorage.setItem("authToken", response.data.token);
                localStorage.setItem("role", response.data.data.role);

                // toast.success("Login Successful!");

                axiosInstance.defaults.headers.Authorization = `Bearer ${response.data.token}`;

                // navigate("/candidate/dashboard");
                checkProfileAndRedirect(navigate);
            } else {
                toast.error(response.data.message || "Login failed!");
            }

        } catch (err) {
            toast.error(err.response?.data?.message || "Login error!");
        }
    };

    const signInWithGoogle = async () => {
        const provider = new GoogleAuthProvider();

        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;

            const nameParts = (user.displayName || "").split(" ");

            const body = {
                login_type: "google",
                email: user.email,
                googleId: user.uid,
                first_name: nameParts[0] || "",
                last_name: nameParts.slice(1).join(" ") || "",
                photo_url: user.photoURL || ""
            };

            const response = await axiosInstance.post(`${API_URL}/login`, body);

            if (response.data.token) {
                localStorage.setItem("authToken", response.data.token);
                localStorage.setItem("role", response.data.data.role);

                axiosInstance.defaults.headers.Authorization = `Bearer ${response.data.token}`;

                checkProfileAndRedirect(navigate);
            } else {
                toast.error("Google login failed!");
            }

        } catch (err) {
            console.error("Google Login Error:", err);
            toast.error(err.response?.data?.message || "Google login error!");
        }
    };

    const handleRegisterClick = () => {
        navigate("/register");
    };

    // const handleLogin = async (event) => {
    //     event.preventDefault();

    //     if (!email || !password) {
    //         toast.error("Please fill in all fields.");
    //         return;
    //     }

    //     if (!captchaToken) {
    //         toast.error("Please complete the CAPTCHA to log in.");
    //         return;
    //     }

    //     const userData = { loginType: "email", email, password };
    //     await loginUser(userData, navigate);

    //     // Clear inputs and reset hCaptcha on success
    //     if (localStorage.getItem("authToken")) {
    //         setEmail("");
    //         setPassword("");
    //         setCaptchaToken(null);
    //         captchaRef.current.resetCaptcha();
    //     }
    // };

    // const signInWithGoogle = async () => {
    //     const provider = new GoogleAuthProvider();
    //     try {
    //         const result = await signInWithPopup(auth, provider);
    //         const user = result.user;

    //         let firstName = "";
    //         let lastName = "";

    //         if (user.displayName && user.displayName.trim() !== "") {
    //             const names = user.displayName.split(" ");
    //             firstName = names[0] || "";
    //             lastName = names.slice(1).join(" ") || "";
    //         }

    //         const userData = {
    //             login_type: "google",
    //             email: user.email,
    //             googleId: user.uid,
    //             photo_url: user.photoURL || '',
    //             first_name: firstName,
    //             last_name: lastName,
    //         };
    //         console.log("Google Login Data:", userData);
    //         await loginUser(userData, navigate);
    //     } catch (error) {
    //         console.error("Google Login Error:", error);
    //     }
    // };

    // const signInWithFacebook = async () => {
    //     const provider = new FacebookAuthProvider();
    //     try {
    //         const result = await signInWithPopup(auth, provider);
    //         const user = result.user;

    //         const [firstName, ...lastNameParts] = (user.displayName || "").split(" ");
    //         const lastName = lastNameParts.join(" ");

    //         const userData = {
    //             login_type: "facebook",
    //             email: user.email,
    //             facebookId: user.uid,
    //             photoUrl: user.photoURL,
    //             first_name: firstName || "",
    //             last_name: lastName || ""
    //         };
    //         console.log("Facebook Login Data:", userData);
    //         await loginUser(userData, navigate);
    //     } catch (error) {
    //         console.error("Facebook Login Error:", error);
    //     }
    // };

    return (

        <>
            <Helmet>
                <title>Login | CV Diffusion</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            <div className="section-full site-bg-white">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-8 col-lg-6 col-md-5 twm-log-reg-media-wrap">
                            <div className="twm-log-reg-media">
                                <JobZImage src="images/login-bg.png" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-7">
                            <div className="twm-log-reg-form-wrap">
                                <div className="twm-log-reg-logo-head">
                                    <NavLink to={publicUser.HOME1}>
                                        <JobZImage src="/images/skins-logo/logo-skin-6.png" alt="" className="logo" />
                                    </NavLink>
                                </div>
                                <div className="twm-log-reg-inner">
                                    <div className="twm-log-reg-head">
                                        <span className="log-reg-form-title">{t("Log In")}</span>
                                    </div>
                                    <div className="twm-tabs-style-2">
                                        {/* <ul className="nav nav-tabs">
                                            <li className="nav-item">
                                                <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#twm-login-candidate" type="button">
                                                    <i className="fas fa-user-tie" /> Candidate
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button className="nav-link" data-bs-toggle="tab" data-bs-target="#twm-login-Employer" type="button">
                                                    <i className="fas fa-building" /> Employer
                                                </button>
                                            </li>
                                        </ul> */}
                                        <div className="tab-content">
                                            {/* Candidate Login */}
                                            <form onSubmit={handleLogin} className="tab-pane fade show active" id="twm-login-candidate">
                                                {/* <div className="form-group mb-3">
                                                    <input type="text" required className="form-control" placeholder="Firstname*" value={firstname} onChange={(e) => setFirstname(e.target.value)} />
                                                </div>
                                                <div className="form-group mb-3">
                                                    <input type="text" required className="form-control" placeholder="Lastname*" value={lastname} onChange={(e) => setLastname(e.target.value)} />
                                                </div> */}
                                                <div className="form-group mb-3">
                                                    <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }} htmlFor="emailInput">{t("Email")} :</label>
                                                    <input
                                                        id="emailInput"
                                                        name="Email"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={`${t("Email")}*`}
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)} />
                                                </div>
                                                <div className="form-group mb-3">
                                                    <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }} htmlFor="passwordInput">{t("Password")} :</label>
                                                    <input
                                                        id="passwordInput"
                                                        name="Password"
                                                        type="password"
                                                        className="form-control"
                                                        placeholder={`${t("Password")}*`}
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)} />
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center mb-4">
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id="rememberMe" />
                                                        <label className="form-check-label" htmlFor="rememberMe">
                                                            {t("Remember me")}
                                                        </label>
                                                    </div>
                                                    <NavLink to={publicUser.pages.FORGOTPASSWORD} className="site-text-primary">
                                                        {t("Forgot Password")}?</NavLink>
                                                </div>
                                                <div className="form-group mb-3">
                                                    <HCaptcha
                                                        sitekey={process.env.REACT_APP_HCAPTCHA_SITE_KEY}
                                                        onVerify={(token) => setCaptchaToken(token)}
                                                        ref={captchaRef} />
                                                </div>
                                                {/* <div className="form-group mb-3">
                                                    <input type="confirm password" className="form-control" required placeholder="Confirm Password*" value={confirmpassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                                </div> */}
                                                <div className="form-group">
                                                    <button type="submit" className="site-button">{t("Log In")}</button>
                                                </div>
                                                <div className="form-group">
                                                    <button
                                                        type="submit"
                                                        className="site-button-register"
                                                        onClick={handleRegisterClick}
                                                    >
                                                        {t("Register")}
                                                    </button>
                                                </div>
                                                <div className="form-group">
                                                    <span className="center-text-or">{t("Or")}</span>
                                                </div>
                                                {/* <div className="form-group">
                                                    <button type="button" className="log_with_facebook" onClick={signInWithFacebook}>
                                                        <i className="fab fa-facebook" /> Continue with Facebook
                                                    </button>
                                                </div> */}
                                                <div className="form-group">
                                                    <button type="button" className="log_with_google" onClick={signInWithGoogle}>
                                                        <JobZImage src="images/google-icon.png" alt="" /> {t("Continue with Google")}
                                                    </button>
                                                </div>
                                            </form>
                                            {/* Employer Login */}
                                            {/* <form onSubmit={handleEmployerLogin} className="tab-pane fade" id="twm-login-Employer">
                                                <div className="form-group mb-3">
                                                    <input type="text" required className="form-control" placeholder="Username*" value={empusername} onChange={(e) => setEmpUsername(e.target.value)} />
                                                </div>
                                                <div className="form-group mb-3">
                                                    <input type="password" className="form-control" required placeholder="Password*" value={password} onChange={(e) => setPassword(e.target.value)} />
                                                </div>
                                                <div className="form-group">
                                                    <button type="submit" className="site-button">Log in</button>
                                                </div>
                                                <div className="form-group">
                                                    <span className="center-text-or">Or</span>
                                                </div>
                                                <div className="form-group">
                                                    <button type="button" className="log_with_facebook" onClick={signInWithFacebook}>
                                                        <i className="fab fa-facebook" /> Continue with Facebook
                                                    </button>
                                                </div>
                                                <div className="form-group">
                                                    <button type="button" className="log_with_google" onClick={signInWithGoogle}>
                                                        <JobZImage src="images/google-icon.png" alt="" /> Continue with Google
                                                    </button>
                                                </div>
                                            </form> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LoginPage;
